const initialState = {
  fetching: false,
};

export default function taskReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'TASKTYPES_FETCHING':
      return { ...currentState, fetching: true };
    case 'TASKTYPES_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    case 'TASK_ADDING':
      return { ...currentState, fetching: true };
    case 'TASK_ADDED':
      return { ...currentState, fetching: false };
    case 'TASK_UPDATING':
      return { ...currentState, fetching: true };
    case 'TASK_UPDATED':
      return { ...currentState, fetching: false };
    case 'TASK_DELETING':
      return { ...currentState, fetching: true };
    case 'TASK_DELETED':
      return { ...currentState, fetching: false };
    default:
      return currentState;
  }
}
